<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <base-modal size="small" :open="active" v-on:close="$emit('close')">
      <!-- #region tabs com opção de criar novo conjunto de parâmetros e importar parâmetros à partir de uma hash -->
      <ontick-div class="w-full px-3 py-6">
        <ontick-text
          size="medium"
          weight="medium"
          align="center"
          class="py-3 text-gray-300"
          style="white-space: wrap !important"
          >Confirme para salvar os parâmetros</ontick-text
        >

        <!-- <ontick-text>Tem certeza que deseja salvar os parâmetros?</ontick-text> -->
        <!-- <ontick-text>modifiedParams: {{ modifiedParams }}</ontick-text> -->

        <!-- Mostra os parâmetros modificados -->
        <!-- <ontick-div v-for="prop_section in Object.keys(modifiedParams)" class="mt-6 first:mt-0">
          <ontick-div orientation="horizontal" :key="prop_section">
              <ontick-text size="medium" color="blue">{{ prop_section }}</ontick-text>
            </ontick-div>
          <ontick-div v-for="(prop_group, i) in Object.keys(modifiedParams[prop_section])" :class="[i == 0 ? 'mt-0' : 'mt-4', 'ml-3']">
            <ontick-div orientation="horizontal" :key="prop_group">
              <ontick-text weight="bold" color="gray">{{ prop_group }}</ontick-text>
            </ontick-div>
            <ontick-div v-for="param in modifiedParams[prop_section][prop_group]" class="pt-2">
              <ontick-div class="px-2 py-1 rounded-lg border border-gray-800 justify-between" orientation="horizontal" :key="param.param_id">
                <ontick-text>{{ param.param_name }}:</ontick-text>
                <ontick-div orientation="horizontal">
                  <ontick-div orientation="horizontal">
                    <ontick-text color="gray" class="pr-1">Antes:</ontick-text>
                    <ontick-text>{{ param.original_value }}</ontick-text>
                  </ontick-div>
                  <ontick-text color="gray" class="px-3">&nbsp;</ontick-text>
                  <ontick-div orientation="horizontal">
                    <ontick-text color="gray" class="pr-1">Depois:</ontick-text>
                    <ontick-text>{{ param.param_value }}</ontick-text>
                  </ontick-div>
                </ontick-div>
              </ontick-div>
              <template v-if="param.param_subparams">
                <ontick-text size="small" weight="medium" color="gray" class="ml-6 pt-1" v-if="param.param_subparams.length > 0">Sub-parâmetros:</ontick-text>
              </template>
              <ontick-div v-for="sub_param in param.param_subparams" class="ml-4">
                <ontick-div class="px-2 py-1 mb-2 rounded-lg border border-gray-800 justify-between" orientation="horizontal" :key="sub_param.param_id">
                  <ontick-text>{{ sub_param.param_name }}:</ontick-text>
                  <ontick-div orientation="horizontal">
                    <ontick-div orientation="horizontal">
                      <ontick-text color="gray" class="pr-1">Antes:</ontick-text>
                      <ontick-text>{{ sub_param.original_value }}</ontick-text>
                    </ontick-div>
                    <ontick-text color="gray" class="px-3">&nbsp;</ontick-text>
                    <ontick-div orientation="horizontal">
                      <ontick-text color="gray" class="pr-1">Depois:</ontick-text>
                      <ontick-text>{{ sub_param.param_value }}</ontick-text>
                    </ontick-div>
                  </ontick-div>
                </ontick-div>
              </ontick-div>
            </ontick-div>
          </ontick-div>
        </ontick-div> -->

        <!-- Nenhum parâmetro encontrado -->
        <!-- <ontick-text v-if="Object.keys(modifiedParams).length == 0" align="center" color="gray" class="pb-6">Nenhum parâmetro modificado</ontick-text> -->
      </ontick-div>
      <!-- #endregion -->

      <!-- #region footer -->
      <template slot="footer">
        <ontick-div
          orientation="horizontal"
          class="border-ontick-graphite-600 justify-end border-t p-3"
        >
          <ontick-button
            size="small"
            color="third"
            class="mr-3"
            @click.native="$emit('close')"
          >
            Cancelar
          </ontick-button>
          <ontick-button size="small" @click.native="$emit('confirm')">
            Salvar
          </ontick-button>
        </ontick-div>
      </template>
      <!-- #endregion -->
    </base-modal>
  </transition>
</template>

<script>
import PincodeInput from "vue-pincode-input";
import { mapActions, mapState } from "vuex";

export default {
  name: "save-modal",
  components: {
    BaseModal: () => import("./base-modal.component"),
    PincodeInput,
  },
  props: {
    active: Boolean,
    modifiedParams: {
      type: Object,
      default: {},
      required: false,
    },
  },
  data() {
    return {
      param: {
        errors: {},
      },
      options: [],
      selected_option: {},
      tab_options: [
        { tag: "novo", name: "Novo" },
        { tag: "importar", name: "Importar" },
      ],
      active_tab: "novo",
      tab_style: {
        all: "flex flex-1 items-center justify-center text-center px-3 py-4 border-b-2 hover:text-white transform transition ease-in-out duration-300 sm:duration-500 transition-all",
        active: "border-ontick-blue-500 text-white font-semibold",
        inactive: "border-ontick-graphite-500 text-gray-400 font-normal",
      },
      //
      code: "",
      styles: {
        button:
          "bg-ontick-third inline-flex items-center px-6 py-3 rounded font-bold text-ontick-light",
        buttonSpan:
          "w-full text-center text-ontick-small text-ontick-white uppercase font-bold",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
// PINCODE COMPONENT
div.vue-pincode-input-wrapper {
  // any styles you want for wrapper
  background-color: #202a37 !important;
  display: flex;
  justify-content: center;
}

input.vue-pincode-input {
  // any styles you want for each cell
  background-color: #171e27 !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
  color: white !important;
  font-size: 40px !important;
  font-weight: 600 !important;
  padding: 6px 12px !important;
  max-width: 75px;
  margin: 12px;
  border: 2px solid #171e27;
  transition: all 0.3s ease;
  &:focus {
    border: 2px solid #07a4ff;
  }
}

p {
  white-space: normal !important;
}

::-webkit-input-placeholder {
  /* Edge */
  color: #a0aec036;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a0aec036;
}
::placeholder {
  color: #a0aec036;
}
</style>
